import { Column } from './types';

export const SORTABLE_COLUMNS = ['name', 'status', 'lastContacted'];

export const SORT_LABELS: Record<string, { asc: string; desc: string }> = {
  status: { asc: 'Lowest to Highest', desc: 'Highest to Lowest' },
  lastContacted: { asc: 'Lowest to Highest', desc: 'Highest to Lowest' },
};

export const Columns: readonly Column[] = [
  { id: 'name', label: 'Name' },
  { id: 'roles', label: 'Title' },
  { id: 'department', label: 'Department' },
  { id: 'phone', label: 'Phone no.' },
  { id: 'email', label: 'Email' },
  { id: 'contactRelationship', label: 'Status' },
  { id: 'lastContacted', label: 'Last Contacted' },
  { id: 'actions', label: '' },
];
